const config = {
    apiProxy: {
        host: 'https://svp-api-proxy-development.int.k8s.linode.stream.schibsted.media',
        path: '/api',
    },
    adminBff: {
        host: 'https://admin-bff-development.int.k8s.linode.stream.schibsted.media',
    },
    playlistsApi: {
        host: 'https://playlists-api-development.int.k8s.linode.stream.schibsted.media',
    },
    mqtt: {
        url: 'wss://mqtt-stage.k8s.linode.stream.schibsted.media',
    },
    podcastsApi: {
        url: 'https://podcasts-api-development.int.k8s.linode.stream.schibsted.media',
    },
    relatedApi: {
        url: 'https://related-api-development.int.k8s.linode.stream.schibsted.media',
    },
    ga: {
        trackingCode: 'UA-129902176-3',
    },
    streamPlayer: {
        src: 'https://cdn.stream.schibsted.media/stream-player/beta/stream-player.min.js',
    },
    player: {
        src: 'https://cdn.stream.schibsted.media/player/beta/player.next.min.js',
        options: {
            api: 'https://svp-stage.vg.no/svp/api/v1/',
            tokenUrl: 'https://token-development.k8s.linode.stream.schibsted.media/svp/token/v1/',
            thumbnailsUrl: 'https://svp-stage.vg.no/svp/thumbnails/v1/',
            locale: 'en',
            settings: {
                preview: true,
                na: true,
                jw: { preload: 'none' },
            },
            sharing: false,
            recommended: false,
            autoplay: false,
            ttsSkin: false,
        },
    },
    publicDisplay: {
        dashboardUrl: 'https://public-display-api-development.int.k8s.linode.stream.schibsted.media',
    },
    datadog: {
        environment: 'development',
        enabled: false,
    },
    live: {
        rtmp: {
            url: 'rtmp://localhost:1935/live',
        },
    },
} as const;

export default config;
